import isArray from 'lodash/isArray';
import isFunction from 'lodash/isFunction';
import React, { Component } from 'react';
import { Capability } from '../../data/account';
import { OrderItemsBy, OrderItemsByOptions } from '../../data/settings';
import Modal from '../../modal';
import UI from '../../ui';
import Utils from '../../utils';
import OrdersUpgradeView from './OrdersUpgradeView.component';

// import PreviewLabelImageModal from '../modals/PreviewSamplePackingSlipModal.component';

const {
	WrappedButton,
	WrappedButtonType,
	WrappedCheckbox,
	WrappedDropdown,
	WrappedInputTextWithLabel,
	WrappedInputTextareaWithLabel,
} = UI;
const { ModalContext } = Modal;
const { Communication, CustStorage, Session } = Utils;

export default class PackingSlipsView extends Component {
	constructor(props) {
		super(props);

		const {
			orderItemsBy = OrderItemsBy.Name,
			showItemPrices = true,
			showItemSkus = true,
			headerText = '',
			bodyText = '',
		} = CustStorage.getItem('packingSlips') || {};

		this.state = {
			orderItemsBy,
			showItemPrices,
			showItemSkus,
			headerText,
			bodyText,
		};
	}

	generateSampleUrl = async () => {
		const { orderItemsBy, showItemPrices, showItemSkus, headerText, bodyText } =
			this.state;
		const { showError } = this.context;

		// set up dates for order params
		const today = new Date();
		const tomorrow = new Date(today);
		tomorrow.setDate(tomorrow.getDate() + 1);

		// sample data params
		const params = {
			Order: {
				AdditionalHandlingCost: 0,
				InsuranceCost: 0,
				OrderDate: today.toISOString(),
				OrderID: 1234567890,
				OrderItems: [
					{
						Description: 'A Sample of Item Description on this Packing Slip',
						Quantity: 2,
						SKU: '100000001',
						UnitPrice: 1.0,
					},
					{
						Description:
							'Another Sample of Item Description on this Packing Slip',
						Quantity: 1,
						SKU: '100000003',
						UnitPrice: 4.99,
					},
					{
						Description:
							'Yet Another Sample of Item Description on this Packing Slip',
						Quantity: 1,
						SKU: '100000002',
						UnitPrice: 2.0,
					},
				],
				ShipCity: 'Anytown',
				ShipCompany: '',
				ShipCountryCode: 'US',
				ShipDate: tomorrow.toISOString(),
				ShipName: 'Packing Slip Sample Recipient',
				ShipPostalCode: '00001',
				ShipState: 'CA',
				ShipStreet1: '123 Main Street',
				ShipStreet2: '',
				ShipStreet3: '',
				ShippingCost: 5.0,
			},
			FromCity: 'Austin',
			FromCompany: '',
			FromCountryCode: 'US',
			FromDate: null,
			FromName: 'Sample Ship From Address',
			FromPostalCode: '78731',
			FromState: 'TX',
			FromStreet1: '4301 Bull Creek Rd Ste 300',
			FromStreet2: '',
			FromStreet3: '',
			OrderItemsBy: orderItemsBy,
			ShowItemPrices: showItemPrices,
			ShowItemSkus: showItemSkus,
			HeaderText: headerText,
			BodyText: bodyText,
		};

		// save sample Packing Slips data to DB
		const response = await Communication.createPackingSlip(params);

		if (Communication.isSuccessful(response)) {
			const sampleUrl = isArray(response.data) ? response.data[0] : '';

			return sampleUrl;
		} else {
			showError({ response });

			return '';
		}
	};

	savePackingSlipsData = async (name, value) => {
		const data = { ...this.state };

		if (name && value) {
			data[name] = value;
		}

		await CustStorage.setItem('packingSlips', data);
	};

	onChangeDropdown = ({ target: { name, value } }) => {
		this.savePackingSlipsData(name, value);

		this.setState({
			[name]: value,
		});
	};

	onChangeCheckbox = ({ target: { name, value } }) => {
		this.savePackingSlipsData(name, !value);

		this.setState(prevState => ({
			[name]: !prevState[name],
		}));
	};

	onChangeInput = ({ target: { name, value } }) => {
		this.setState({
			[name]: value,
		});
	};

	onClickDone = async () => {
		const { closeSettings, completionCallback } = this.props;

		await this.savePackingSlipsData();

		if (isFunction(closeSettings)) {
			closeSettings();
		} else {
			completionCallback(true);
		}
	};

	onClickPreviewSample = async () => {
		const { renderSamplePreviewModalFromWrapper } = this.props;

		const sampleUrl = await this.generateSampleUrl();

		// render sample preview modal in Ext
		if (isFunction(renderSamplePreviewModalFromWrapper)) {
			renderSamplePreviewModalFromWrapper(sampleUrl);
		} else {
			// TODO: Call PreviewLabelImageModal to render the React modal once it's no longer embedded in an iframe.
		}
	};

	render() {
		const { orderItemsBy, showItemPrices, showItemSkus, headerText, bodyText } =
			this.state;

		if (!Session.hasCapability(Capability.CanUseOrders)) {
			return <OrdersUpgradeView />;
		}

		return (
			<div className="settings-orders-packing-slips-view">
				<div className="settings-body">
					<div
						className="settings-content-header"
						data-qa="ui-text-header-packingslips-itemdetailssection"
						{...{ dataqa: 'ui-text-header-packingslips-itemdetailssection' }}
					>
						<p>Packing Slips</p>
					</div>
					<div className="p-grid p-dir-col">
						<div
							className="p-col-12"
							data-qa="ui-text-description-packingslips-itemdetailssection"
							{...{
								dataqa: 'ui-text-description-packingslips-itemdetailssection',
							}}
						>
							<p>Customize the packing slips you print from the Orders page.</p>
						</div>
						<div className="settings-section-container">
							<div className="p-col-12">
								<div className="settings-label">Order items by</div>
								<div className="packing-slips-input-container">
									<WrappedDropdown
										name="orderItemsBy"
										options={OrderItemsByOptions}
										optionLabel="name"
										optionValue="value"
										value={orderItemsBy}
										onChange={this.onChangeDropdown}
										dataqa="packingslips-orderitemsby"
									>
										Include item prices on packing slips
									</WrappedDropdown>
								</div>
							</div>
							<div className="p-col-12">
								<WrappedCheckbox
									inputId="settings-item-prices"
									name="showItemPrices"
									onChange={this.onChangeCheckbox}
									checked={showItemPrices}
									value={showItemPrices}
									dataqa="settings-packingslips-itemprices"
								>
									<span
										data-qa="ui-label-text-settings-packingslips-itemprices"
										{...{
											dataqa: 'ui-label-text-settings-packingslips-itemprices',
										}}
									>
										Include item prices
									</span>
								</WrappedCheckbox>
							</div>
							<div className="p-col-12">
								<WrappedCheckbox
									inputId="settings-item-skus"
									name="showItemSkus"
									onChange={this.onChangeCheckbox}
									checked={showItemSkus}
									value={showItemSkus}
									dataqa="settings-packingslips-itemskus"
								>
									<span
										data-qa="ui-label-text-settings-packingslips-itemskus"
										{...{
											dataqa: 'ui-label-text-settings-packingslips-itemskus',
										}}
									>
										Include item SKUs
									</span>
								</WrappedCheckbox>
							</div>
						</div>
					</div>
					<div className="p-grid p-dir-col">
						<div className="settings-section-container custom-message">
							<div
								className="settings-content-header"
								data-qa="ui-text-header-packingslips-custommessagesection"
								{...{
									dataqa: 'ui-text-header-packingslips-custommessagesection',
								}}
							>
								<p>Custom Message</p>
							</div>
							<div className="p-grid p-dir-col">
								<div
									className="p-col-12"
									data-qa="ui-text-description-packingslips-custommessagesection"
									{...{
										dataqa:
											'ui-text-description-packingslips-custommessagesection',
									}}
								>
									<p>
										Include a custom message at the bottom of the packing slip.
									</p>
								</div>
								<div className="p-col-12 settings-section-form-container">
									<div
										className="settings-label"
										data-qa="ui-label-packingslips-headertext"
										{...{ dataqa: 'ui-label-packingslips-headertext' }}
									>
										Header
									</div>
									<WrappedInputTextWithLabel
										className="packing-slips-input-container"
										uiElementConfig={{
											name: 'headerText',
											value: headerText,
											placeholder: 'Ex: Return Instructions',
											onChange: this.onChangeInput,
											maxLength: '50',
											dataqa: 'ui-input-packingslips-headerinput',
										}}
									/>
								</div>
								<div className="p-col-12 body-text-row settings-section-form-container">
									<div
										className="settings-label"
										data-qa="ui-label-packingslips-bodytext"
										{...{ dataqa: 'ui-label-packingslips-bodytext' }}
									>
										Body
									</div>
									<div className="packing-slips-input-container">
										<WrappedInputTextareaWithLabel
											uiElementConfig={{
												rows: 6,
												name: 'bodyText',
												value: bodyText,
												onChange: this.onChangeInput,
												maxLength: '500',
												dataqa: 'ui-input-packingslips-bodyinput',
											}}
										/>
										<span
											className="body-text-counter"
											data-qa="ui-text-packingslips-bodytextcounter"
											{...{ dataqa: 'ui-text-packingslips-bodytextcounter' }}
										>
											{500 - bodyText.length}/500
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="settings-content-footer">
					<WrappedButton
						className="settings-button"
						label="Done"
						type="button"
						onClick={this.onClickDone}
						buttonType={WrappedButtonType.Primary}
						dataqa="packingslips-primarybutton-done"
					/>
					<WrappedButton
						className="settings-button"
						label="Preview Sample"
						type="button"
						onClick={this.onClickPreviewSample}
						buttonType={WrappedButtonType.Secondary}
						dataqa="packingslips-secondarybutton-previewsample"
					/>
				</div>
			</div>
		);
	}
}

PackingSlipsView.contextType = ModalContext;
